require('./navigation-header.jade')
_ = require("lodash")

pathsToShow = [
  '/'
  '/history'
  '/analysis'
  '/groups'
]

GROUP_PATH_REGEX = /^\/groups\/.*|\/group-event\/.*|\/analysis-event\/.*$/

NavigationHeaderDirective = ($location) ->
  restrict: 'A'
  replace: false
  templateUrl: 'components/navigation-header/navigation-header.jade'
  require: '^gnp-common-header'
  link: (scope, element, attrs, commonHeaderCtrl) ->
    path = $location.path()
    showNavigation = _.includes(pathsToShow, path)
    haveGroup =  GROUP_PATH_REGEX.test(path)
    if haveGroup
      showNavigation = haveGroup
    commonHeaderCtrl.includeNavigation showNavigation
    scope.mixPanelEventPrefix =
      if path is '/'
        'DSB'
      else if path is '/history'
        'HST'
      else if path is '/groups'
        'GRP'
      else
        'ANL'
    scope.showNavigation = showNavigation
    scope.canHighlight = (path) ->
      return $location.path() is path || ( path == '/groups' && GROUP_PATH_REGEX.test($location.path()))
    scope.showRegisGroup = ->
      scope.canHighlight('/groups')

NavigationHeaderDirective.$inject = [
  "$location"
]

module.exports = NavigationHeaderDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/navigation-header/navigation-header-directive.coffee